import { glassTextures } from '../data/mockData';

/** Config Go quote line — Double Glass 24 mm (HR++) */
export const VMK_GLAZING_LABEL_24 = 'HR++ - 5-15-4*';

/** Config Go quote line — Double Glass 36 mm (HR++) — merged PDF uses HR+++ prefix */
export const VMK_GLAZING_LABEL_36 = 'HR+++ - 4-12-4-12-4*';

/** @deprecated Use getVmkGlazingBaseLabel — kept for imports that expect 24 mm default */
export const VMK_GLAZING_LABEL = VMK_GLAZING_LABEL_24;

const GLAZING_36_IDS = new Set(['triple', 'double-36']);

/** Configurator glazingType id → 36 mm HR++ */
export const isGlazing36mm = (glazingTypeId) =>
  GLAZING_36_IDS.has(glazingTypeId);

/** Dominant glazing for VMK spec page — triple if any line item uses 36 mm glazing. */
export const resolveOrderGlazingTypeId = (savedQuotes = []) => {
  const ids = [];

  savedQuotes.forEach((quote) => {
    const config = quote?.config;
    if (!config) return;
    if (config.glazingType) ids.push(config.glazingType);
    if (config.rightGlazingType) ids.push(config.rightGlazingType);
  });

  if (ids.some((id) => isGlazing36mm(id))) {
    return 'triple';
  }

  if (ids.length > 0) {
    return 'double';
  }

  return 'double';
};

export const isOrderTripleGlazing = (savedQuotes = []) =>
  isGlazing36mm(resolveOrderGlazingTypeId(savedQuotes));

/** Normalise legacy ids: double / double-24 → 24 mm; triple / double-36 → 36 mm */
export const normalizeGlazingTypeId = (glazingTypeId) =>
  (isGlazing36mm(glazingTypeId) ? '36' : '24');

export const getVmkGlazingBaseLabel = (glazingTypeId) =>
  (isGlazing36mm(glazingTypeId) ? VMK_GLAZING_LABEL_36 : VMK_GLAZING_LABEL_24);

const getTextureSuffix = (glassTextureId) => {
  const texture = glassTextureId
    ? glassTextures.find((g) => g.id === glassTextureId)
    : null;
  if (!texture || texture.id === 'helder-glas' || texture.id === 'clear') {
    return '';
  }
  if (texture.name?.toUpperCase().includes('CHINCHILLA')) {
    return ' CHINCHILLA BLANK';
  }
  if (texture.name?.toUpperCase().includes('SATIN')) {
    return ' SATIJN';
  }
  return ` ${texture.name?.toUpperCase() || ''}`;
};

/** Full VMK quote glazing description (HR++ code + optional texture suffix). */
export const getVmkGlazingLabel = (config) => {
  const base = getVmkGlazingBaseLabel(config?.glazingType);
  return `${base}${getTextureSuffix(config?.glassTexture)}`;
};
